import { render, staticRenderFns } from "./XeroConfiguration.vue?vue&type=template&id=656b539c&scoped=true&"
import script from "./XeroConfiguration.vue?vue&type=script&lang=js&"
export * from "./XeroConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./XeroConfiguration.vue?vue&type=style&index=0&id=656b539c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656b539c",
  null
  
)

export default component.exports